export default "/react/message-9cb9aaa5.svg";